import React, { FC, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { Card } from "react-bootstrap";
import { GET_ANALYTICS_REVISIONS } from "../../../graphql/queries";
import {
    AnalyticsRevisionData,
    AnalyticsRevisionVariables,
    Project
} from "../../../models/types";
import { FunnelRevision } from "../../simple/analytics/FunnelRevision";

interface Props {
    project: Project;
    show: boolean;
}

export const AnalyticsRevisions: FC<Props> = ({ project, show }) => {
    const [fetchAnalyticsProjects, { loading, data, error }] = useLazyQuery<
        AnalyticsRevisionData,
        AnalyticsRevisionVariables
    >(GET_ANALYTICS_REVISIONS, {
        variables: {
            projectId: project.id
        }
    });

    useEffect(() => {
        if (show) {
            fetchAnalyticsProjects();
        }
    }, [show]);

    const renderList = () => {
        if (loading) {
            return <div>Loading...</div>;
        }
        if (error) {
            return <div>Error: {error.message}</div>;
        }
        if (!data) {
            return null;
        }

        if (data.analyticsRevisions.length === 0) {
            return (
                <Card.Body className="p-2 medium-font">
                    No revisions with analytics enabled.
                </Card.Body>
            );
        }

        return data.analyticsRevisions.map(revision => (
            <FunnelRevision key={revision.id} revision={revision} />
        ));
    };

    return <div>{renderList()}</div>;
};
